import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

/** Queries scoped by category contact access via API `filterBySession`. */
const categoryAccessQueries = [
  'waiverCategories',
  'waiverCategoryUsers',
  'waiverTemplates',
  'waiverPublishedTemplates',
  'waiverTemplate',
  'waiverForms',
  'waiverForm',
  'waiverContents',
  'waiverQuestions',
  'waiverLists',
  'waiverFormSubmissions',
  'waiverDashboardSummary',
  'waiverDashboardSubmissionVolume',
  'waiverDashboardFormSubmissions',
  'waiverDashboardFormsByCategory',
];

const waiverCategoryMutations: UpdatesConfig['Mutation'] = {
  waiverCategoryCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverCategories', cache);
  },
  waiverCategoryUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(categoryAccessQueries, cache);
  },
  waiverCategoryUserUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(categoryAccessQueries, cache);
  },
  waiverCategoryContactsUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(categoryAccessQueries, cache);
  },
  waiverCategoryStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(categoryAccessQueries, cache);
  },
};

export default waiverCategoryMutations;
